import React from "react";
import styled from "styled-components";
import { devices } from "../../styles";

export default function Footer() {
  return (
    <FooterContent>

      <FooterInner>
        <div style={{"paddingTop":"44px"}}>
          <div>
            <img className="logo" src="./logo_cls.svg" width="159" height="35" alt="logo cls" />
          </div>
          <div>
            <h3>Address</h3>
            <p>Vifor Pharma Management Ltd.Flughofstrasse 61, P.O. Box, CH- 8152 Glattbrugg, Switzerland.</p>
          </div>
          <div>
            <h3>Stay in touch</h3>
            <p>Keep up to date on social media or contact us with any other information.</p>
            <p style={{"marginTop": "-10px"}}>+41 58 851 80 00</p>
            <div style={{"marginBottom": "18px"}}>
              <a href="https://www.linkedin.com/company/vifor-pharma/" target="_blank">
                <img className="share" src="./share-linkedin-red.svg" width="20" height="21" alt="Share Linkedin" />
              </a>
              <a href="https://www.youtube.com/channel/UC5tU1fqMdz4z-Fo3xHzQ4ow" target="_blank">
                <img className="share" src="./share-youtube-red.svg" alt="Share Youtube" width="20" height="22" />
                </a>
              <a href="https://twitter.com/viforpharma" target="_blank">
                <img className="share" src="./share-twitter-red.svg" width="20" height="22" alt="Share Twitter" />
              </a>
            </div>
          </div>
          <div>
            <h3>Sign up for alerts</h3>
            <p>Be notified of any news, reports or updates straight to your email address.</p>
            <img style={{"display" : "inline"}} alt="Envelope" width="18" height="15" src={"./signup_icon_red.svg"} /> 
            <a href="https://pbmirondeficiency.com/optin-form" target="_blank">
              Sign up and get the latest news
            </a>
          </div>
        </div>

        <hr />
        <p className="promo">Vifor Pharma is a global pharmaceutical company. It aims to become a global leader in iron deﬁciency, nephrology and cardio-renal therapies. Vifor Pharma strives to help patients around the world lead better, healthier lives in heart failure, kidney disease, gastroenterology or inflammatory bowel disease, patient blood management and woman’s health. The company develops, manufactures and markets pharmaceutical products for precision patient care. For more information about Vifor Pharma, please visit <a target="_blank" href="http://www.viforpharma.com">www.viforpharma.com</a></p>
        {/*<a className={"more"} href="#">View MORE</a>*/}

      </FooterInner>

      <Copright>
        <FooterInner>
        <ul style={{"marginLeft":"-24px"}}>
          <li><a taget="_blank" href="https://www.viforpharma.com/terms-use">Terms of use </a></li>
          <li><a taget="_blank" href="https://www.viforpharma.com/privacy-policy">Privacy policy</a></li>
          <li><a taget="_blank" href="https://www.viforpharma.com/cookie-policy">Cookie POLICY</a></li>
          <li><a taget="_blank" href="https://www.viforpharma.com/cookie-policy">Cookie PREFERENCES</a></li>
        </ul>
        <label>HQ-NA-2200164 December 2022</label>
        </FooterInner>
      </Copright>


    </FooterContent>
  )}


const FooterContent = styled.div`
  background-color: white;
  > div > div {
    font-family: 'Montserrat';

    @media ${devices.M} {
      display: flex;
      gap: 60px;
      width: 100%;
    }
    h3 {
      font-style: normal;
      font-weight: 700;
      font-size: 18px;
      line-height: 32px;
      color: rgba(59, 43, 43, 1)
    }
  
    p {
      font-style: normal;
      font-weight: 400;
      font-size: 13px;
      line-height: 20px;
    }
  }

  a { 
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    align-items: center;
    color: #D60E41;
    text-decoration: none;
    vertical-align: top;
  }

  a.more { 
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    text-transform: uppercase;
    color: #000000;
  }

  p.promo {
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 21px;
    /* or 150% */
    letter-spacing: -0.3px;
    color: #3B2B2B;
    a {
      text-decoration: underline;
      color: black;
      font-weight: 300;
    }
  }

  hr {
    height: 1px;
    mix-blend-mode: normal;
    //opacity: 0.1;
    border: 1px solid #F7F7F7;
    margin: 24px 0;
  }

  img {
    margin-right: 5px;
  }

  img.logo {
    margin-bottom:32px;

`;

const Copright = styled.div`
  background: #F7F7F7;
  @media ${devices.M} {
    display: flex;
  }
  ul {
    display: flex;
    @media ${devices.M} {
      display: flex;
    }
    margin-bottom: 32px;
    padding-top:32px;
    row-gap: 20px;
    flex-wrap: wrap;
    li {
      border-right: 1px solid black;

      &:last-child {
        border-right: none;
      }
      a {
        white-space: nowrap;
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 15px;
        /* identical to box height */
        text-transform: uppercase;
        color: #3B2B2B;
        padding: 0 24px;
        border-right: 1px;
        display: block;
      }
    }

  }
  label {
    white-space: nowrap;
    flex-grow: 1;
    text-align: right;
    display: inline-block;
    @media ${devices.L} {
      padding-top: 32px;
    }
  }
`;


const FooterInner = styled.div`
  max-width: 1165px;
  margin: 0 auto;
  @media ${devices.S} {
    padding: 0 16px;
  }
  @media ${devices.M} {
    padding: 0 20px;
  }
  @media ${devices.L} {
    padding: 0;
  }
  > div {
    a img {
      margin-right: 10px;
    }
  }
}
`;